import React from "react";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelWeight } from "../../functions/Report.ExportWeight";
import { formatDataWeight } from "../../utils/Report.Format";
import { displayValue } from "../../../../components/functions/Functions";
import {
  SCREENIPAD,
  STYLEHEAD,
  FLEXDROPDOWN,
  TABLE,
  LEFTTABLE,
  RIGHTTABLE,
  TRTABLE,
  TXCENTER,
} from "../../../../utils/useStyle";

// tab02 Demographic ของผู้เข้ารับบริการ
const ReportWeight = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    min: 0,
    max: 0,
    median: 0,
    mode: [],
    average: 0,
    sumAll: 0,
    count: 0,
    sd: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getWeightReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching weight report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  return (
    <>
      <div>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>น้ำหนักตัวผู้ป่วย</div>
              <div className={FLEXDROPDOWN}>
                <FilterYearType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                />
                <ButtonExcel
                  onClick={() => {
                    ExcelWeight(formatDataWeight(data), year, type, setLoading);
                  }}
                  loading={loading}
                />
              </div>
            </div>

            <table className={TABLE}>
              <thead>
                <tr>
                  <th className={LEFTTABLE}>รายการ</th>
                  <th className={RIGHTTABLE}>ค่าสถิติ</th>
                </tr>
              </thead>
              <tbody>
                <tr className={TRTABLE}>
                  <td className={TXCENTER}> Mean </td>
                  <td className={TXCENTER}> {displayValue(data?.mean)}</td>
                </tr>
                <tr className={TRTABLE}>
                  <td className={TXCENTER}>Median </td>
                  <td className={TXCENTER}> {displayValue(data?.median)}</td>
                </tr>
                <tr className={TRTABLE}>
                  <td className={TXCENTER}>Min </td>
                  <td className={TXCENTER}> {displayValue(data?.min)}</td>
                </tr>
                <tr className={TRTABLE}>
                  <td className={TXCENTER}>Max </td>
                  <td className={TXCENTER}>{displayValue(data?.max)}</td>
                </tr>
                <tr className={TRTABLE}>
                  <td className={TXCENTER}> SD </td>
                  <td className={TXCENTER}>{displayValue(data?.sd)}</td>
                </tr>
                <tr className={TRTABLE}>
                  <td className={TXCENTER}> n </td>
                  <td className={TXCENTER}>{displayValue(data?.count)}</td>
                </tr>
              </tbody>
            </table>
          </>
        </div>
      </div>
    </>
  );
};

export default ReportWeight;
